<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <div class="col-xl-12">
                <div class="card card-header-actions mx-auto">
                    <div class="card-header">
                        Pay Web Component
                    </div>
                    <div class="card-body">
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>